import actions from "./actions";

const initState = {
  listBlog: [],
  isLoading: false,
  currentBlog: {},
};

export default function BlogReducer(state = initState, action) {
  switch (action.type) {
    case actions.SET_LIST_BLOG:
      return {
        ...state,
        listBlog: action.payload,
        isLoading: false,
      };
    case actions.SET_IS_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    case actions.SET_CURRENT_BLOG:
      return {
        ...state,
        currentBlog: action.payload,
      };
    default:
      return state;
  }
}
